/**
 * The name of the screen, and whatever caption belongs beside it.
 *
 * It carries its own space below rather than taking the one `main` puts
 * between every pair of children: a heading spaced from its content exactly as
 * two cards are spaced from each other reads as the first item of the list
 * instead of the name of the page.
 *
 * The app's name is not here. The sidebar heads with WEB DEPLOYMENT / {app.name} at
 * this same size and the menu row is lit — the head names the screen.
 *
 * On a phone the title is not drawn: the app header's eyebrow names the
 * screen there, and the same word twice, a line apart, read as a mistake.
 * Only the caption stays, when there is one.
 */
const ScreenHead = ({ title, children, className = '' }: {
  title: React.ReactNode,
  /** A caption on the same line from `lg` up, alone on a phone. */
  children?: React.ReactNode,
  className?: string,
}) => (
  <div className={`${children ? 'flex' : 'hidden lg:flex'} flex-col items-start gap-1.5 mb-2 lg:mb-4 lg:flex-row lg:flex-wrap lg:items-center lg:gap-x-3 ${className}`}>
    <h1 className="hidden lg:block font-sora text-ds-20 font-semibold tracking-[-0.02em] leading-[1.2] text-white">
      {title}
    </h1>
    {children}
  </div>
)

export default ScreenHead
